import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, Backdrop } from '@mui/material';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchCaptcha, submitEDM, fetchChannel } from "../../redux/actions/edmAction.js";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import i18n from '../../i18n';
import { useHistory } from "react-router-dom";
import EDMHeader from "./EDMHeader";
import EDMFooter from "./EDMFooter";
import { useFormik } from 'formik';
import DataPrivacyContent from '../DataPrivacyContent';
import { changeLanguage } from "i18next";

const useStyles = makeStyles((theme) => ({
    edmStyle: {
        fontFamily: "Montserrat, Noto Sans TC, Noto Sans SC, Arial, Helvetica, sans-serif !important",
    },
    header: {
        width: "100%",
        backgroundColor: "#243d77",
        textAlign: "center",
        color: "white",
        position: "sticky",
        top: "0",
        padding: "0 0 15px 0"
    },
    bannerContainer: {
        height: "150px",
        position: "relative"
    },
    bannerVerticalCenter: {
        margin: "0",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        textAlign: "center",
        width: "100%",
        fontSize: "30px"
    },
    body: {
        marginBottom: "50px"
    },
    form: {
        maxWidth: "400px",
        margin: "auto",
        padding: "10px"
    },
    title: {
        backgroundColor: "#f1f1f1",
        verticalAlign: "middle",
    },
    footer: {
        width: "100%",
        backgroundColor: "#243d77",
        textAlign: "center",
        color: "white",
        position: "fixed",
        bottom: "0",
        padding: "10px 0"
    },
    mandatoryLabel: {
        color: "#f38660"
    },
    submitButton: {
        width: "200px",
        margin: "auto",
        backgroundImage: "linear-gradient(#f7925a, #f15a23)",
        border: "none"
    },
    captchaStyle: {
        width: "100px",
        height: "40px"
    },
    errorMsg: {
        color: "#ff0000",
        fontSize: "12px"
    }
}));

function EDMTWSubmit() {
    const { t } = useTranslation();
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const captchaB64Str = useSelector((state) => state.captchaB64Str);
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState("");
    const [modalContent, setModalContent] = useState("");
    const [isLoading, setLoading] = useState(false);

    const initialValues = {
        title: "",
        firstName: "",
        familyName: "",
        mobileCountryCode: "",
        mobileNumber: "",
        email: "",
        captchaCode: "",
        referenceNo: "edm-twpc"
    };    

    const validate = values => {        
        const errors = {};
        if(!values.title) {
            errors.title = "EDM.Required";
        }
        if(!values.firstName) {
            errors.firstName = "EDM.Required";
        }
        if(!values.familyName) {
            errors.familyName = "EDM.Required";
        }
        if(!values.mobileCountryCode) {
            errors.mobileCountryCode = "EDM.Required";
        }
        if(!values.mobileNumber) {
            errors.mobileNumber = "EDM.Required";
        }
        if(!values.email) {
            errors.email = "EDM.Required";
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
            errors.email = "EDM.InvalidEmailFormat";
        }
        if(!values.captchaCode) {
            errors.captchaCode = "EDM.Required";
        }
        if (values.mobileCountryCode && values.mobileNumber) {
            if (values.mobileCountryCode === "852" && values.mobileNumber.length !== 8) {
                errors.mobileNumber = "EDM.MobileNumberlengthIncorrect".replace("{0}", 8);
            }
            if (values.mobileCountryCode === "86" && values.mobileNumber.length !== 11) {
                errors.mobileNumber = "EDM.MobileNumberlengthIncorrect".replace("{0}", 11);
            }
        }

        return errors;
    }

    const formik = useFormik( {
        initialValues: initialValues,
        validateOnChange: false,
        validate,
        onSubmit: values => {handleEDMSubmit(values);}
    });

    useEffect(() => {
        setDefaultLang();
        document.title = `${t('KGI Asia')} - ${t('EDM.FormTitleTW')}`;
        refreshCaptcha();
    }, [dispatch]);

    function refreshCaptcha() {
        dispatch(fetchCaptcha());
    }

    function setDefaultLang() {
        i18n.changeLanguage('CHT');
    }

    async function handleEDMSubmit(values) {
        setLoading(true);
        let isCaptchaPass = await dispatch(submitEDM(values));
        if (isCaptchaPass) {
            history.push("/edm/confirm-tw");
        } else {
            formik.setErrors({captchaCode: t("EDM.InvalidCaptchaCode")});
        }
        setLoading(false);
    }
  
    function showDataPrivacy() {
        setModalHeader(t("PersonalInformationCollectionStatement"));
        setModalContent(<DataPrivacyContent/>);
        setShowModal(true);
    }

    function handleCloseModal() {
        setShowModal(false);
    }

    function getMobileNoErrorMsg(error) {
        if (formik.values.mobileCountryCode === "852") {
            return t(error).replace("{0}", 8);
        } else if (formik.values.mobileCountryCode === "86") {
            return t(error).replace("{0}", 11);
        } else {
            return t(error)
        }
    }

    return (
        <div className={classes.edmStyle}>
            <div className={classes.header}>
                <EDMHeader props={{allowChangeLang: false}}/>
                <div className={classes.bannerContainer}>
                    <div className={classes.bannerVerticalCenter}>
                        <img src={`${process.env.REACT_APP_ROUTER_BASE_URL}/media/research_icon.png`} style={{width: "50px"}} alt="research"></img>
                        <strong style={{marginLeft: "15px"}}>{t("EDM.FormTitleTW")}</strong>
                    </div>
                </div>
            </div>

            <div className={classes.body}>
                <div style={{padding: "10px 30px", maxWidth: "650px", margin: "auto"}}>
                    <div>
                        <center><p>{t("EDM.FormDescTW")}</p></center>
                    </div>
                </div>
                <Form onSubmit={formik.handleSubmit}>
                {/* <Form onSubmit={(e) => {

                    formik.handleSubmit();
                }}> */}
                    <div className={classes.title}>
                        <div key="inline" className={classes.form + " mb-3"} style={{padding: "10px 10px 0 10px"}}>
                            <Form.Label>{t("EDM.Title")}*</Form.Label>
                            <Form.Check inline type="radio" name="title" value="MR" label={t("EDM.Mr")} style={{marginLeft: "30px"}} onChange={formik.handleChange} onBlur={formik.handleBlur} defaultChecked={formik.values.title === "MR"} />
                            <Form.Check inline type="radio" name="title" value="MS" label={t("EDM.Ms")} onChange={formik.handleChange} onBlur={formik.handleBlur} defaultChecked={formik.values.title ==="MS"}/>
                            <span className={classes.errorMsg}>{formik.errors.title && formik.touched.title && t(formik.errors.title)}</span>
                        </div>
                    </div>
                    
                    <div className={classes.form}>
                        <Row>
                            <Form.Label>{t("EDM.FirstName")}*</Form.Label>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Form.Control type="text" name="firstName" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.firstName} />
                                <span className={classes.errorMsg}>{formik.errors.firstName && formik.touched.firstName && t(formik.errors.firstName)}</span>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Form.Label>{t("EDM.FamilyName")}*</Form.Label>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Form.Control type="text" name="familyName" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.familyName} />
                                <span className={classes.errorMsg}>{formik.errors.familyName && formik.touched.familyName && t(formik.errors.familyName)}</span>
                            </Col>
                        </Row>
                        
                        <Row className="mt-3">
                            <Form.Label>{t("EDM.MobileNumber")}*</Form.Label>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Form.Select name="mobileCountryCode" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.mobileCountryCode}>
                                    <option></option>
                                    <option value="852">{t("EDM.Country.HKG")}</option>
                                    <option value="86">{t("EDM.Country.CHN")}</option>
                                    <option value="886">{t("EDM.Country.TWN")}</option>
                                    <option value="62">{t("EDM.Country.IDN")}</option>
                                    <option value="65">{t("EDM.Country.SGP")}</option>
                                    <option value="66">{t("EDM.Country.THA")}</option>
                                    <option value="81">{t("EDM.Country.JPN")}</option>
                                    <option value="853">{t("EDM.Country.MAC")}</option>
                                    <option value="93">{t("EDM.Country.AFG")}</option>
                                    <option value="355">{t("EDM.Country.ALB")}</option>
                                    <option value="213">{t("EDM.Country.DZA")}</option>
                                    <option value="1-684">{t("EDM.Country.ASM")}</option>
                                    <option value="376">{t("EDM.Country.AND")}</option>
                                    <option value="244">{t("EDM.Country.AGO")}</option>
                                    <option value="1-264">{t("EDM.Country.AIA")}</option>
                                    <option value="672">{t("EDM.Country.ATA")}</option>
                                    <option value="1-268">{t("EDM.Country.ATG")}</option>
                                    <option value="54">{t("EDM.Country.ARG")}</option>
                                    <option value="374">{t("EDM.Country.ARM")}</option>
                                    <option value="297">{t("EDM.Country.ABW")}</option>
                                    <option value="61">{t("EDM.Country.AUS")}</option>
                                    {/* <option value="43">{t("EDM.Country.AUT")}</option> */}
                                    <option value="994">{t("EDM.Country.AZE")}</option>
                                    <option value="1-242">{t("EDM.Country.BHS")}</option>
                                    <option value="973">{t("EDM.Country.BHR")}</option>
                                    <option value="880">{t("EDM.Country.BGD")}</option>
                                    <option value="1-246">{t("EDM.Country.BRB")}</option>
                                    <option value="375">{t("EDM.Country.BLR")}</option>
                                    {/* <option value="32">{t("EDM.Country.BEL")}</option> */}
                                    <option value="501">{t("EDM.Country.BLZ")}</option>
                                    <option value="229">{t("EDM.Country.BEN")}</option>
                                    <option value="1-441">{t("EDM.Country.BMU")}</option>
                                    <option value="975">{t("EDM.Country.BTN")}</option>
                                    <option value="591">{t("EDM.Country.BOL")}</option>
                                    <option value="387">{t("EDM.Country.BIH")}</option>
                                    <option value="267">{t("EDM.Country.BWA")}</option>
                                    {/* <option value="">{t("EDM.Country.BVT")}</option> */}
                                    <option value="55">{t("EDM.Country.BRA")}</option>
                                    <option value="246">{t("EDM.Country.IOT")}</option>
                                    <option value="673">{t("EDM.Country.BRN")}</option>
                                    {/* <option value="359">{t("EDM.Country.BGR")}</option> */}
                                    <option value="226">{t("EDM.Country.BFA")}</option>
                                    <option value="257">{t("EDM.Country.BDI")}</option>
                                    <option value="855">{t("EDM.Country.KHM")}</option>
                                    <option value="237">{t("EDM.Country.CMR")}</option>
                                    <option value="1">{t("EDM.Country.CAN")}</option>
                                    <option value="238">{t("EDM.Country.CPV")}</option>
                                    <option value="1-345">{t("EDM.Country.CYM")}</option>
                                    <option value="236">{t("EDM.Country.CAF")}</option>
                                    <option value="235">{t("EDM.Country.TCD")}</option>
                                    <option value="56">{t("EDM.Country.CHL")}</option>
                                    <option value="61">{t("EDM.Country.CXR")}</option>
                                    <option value="61">{t("EDM.Country.CCK")}</option>
                                    <option value="57">{t("EDM.Country.COL")}</option>
                                    <option value="269">{t("EDM.Country.COM")}</option>
                                    <option value="682">{t("EDM.Country.COK")}</option>
                                    <option value="506">{t("EDM.Country.CRI")}</option>
                                    {/* <option value="385">{t("EDM.Country.HRV")}</option> */}
                                    <option value="53">{t("EDM.Country.CUB")}</option>
                                    <option value="599">{t("EDM.Country.CUW")}</option>
                                    {/* <option value="357">{t("EDM.Country.CYP")}</option> */}
                                    {/* <option value="420">{t("EDM.Country.CZE")}</option> */}
                                    <option value="243">{t("EDM.Country.COD")}</option>
                                    {/* <option value="45">{t("EDM.Country.DNK")}</option> */}
                                    <option value="253">{t("EDM.Country.DJI")}</option>
                                    <option value="1-767">{t("EDM.Country.DMA")}</option>
                                    <option value="1-809, 1-829, 1-849">{t("EDM.Country.DOM")}</option>
                                    <option value="670">{t("EDM.Country.TLS")}</option>
                                    <option value="593">{t("EDM.Country.ECU")}</option>
                                    <option value="20">{t("EDM.Country.EGY")}</option>
                                    <option value="503">{t("EDM.Country.SLV")}</option>
                                    <option value="240">{t("EDM.Country.GNQ")}</option>
                                    <option value="291">{t("EDM.Country.ERI")}</option>
                                    {/* <option value="372">{t("EDM.Country.EST")}</option> */}
                                    <option value="251">{t("EDM.Country.ETH")}</option>
                                    <option value="500">{t("EDM.Country.FLK")}</option>
                                    <option value="298">{t("EDM.Country.FRO")}</option>
                                    <option value="679">{t("EDM.Country.FJI")}</option>
                                    {/* <option value="358">{t("EDM.Country.FIN")}</option> */}
                                    {/* <option value="33">{t("EDM.Country.FRA")}</option> */}
                                    {/* <option value="">{t("EDM.Country.GUF")}</option> */}
                                    <option value="689">{t("EDM.Country.PYF")}</option>
                                    {/* <option value="">{t("EDM.Country.ATF")}</option> */}
                                    <option value="241">{t("EDM.Country.GAB")}</option>
                                    <option value="220">{t("EDM.Country.GMB")}</option>
                                    <option value="995">{t("EDM.Country.GEO")}</option>
                                    {/* <option value="49">{t("EDM.Country.DEU")}</option> */}
                                    <option value="233">{t("EDM.Country.GHA")}</option>
                                    <option value="350">{t("EDM.Country.GIB")}</option>
                                    {/* <option value="30">{t("EDM.Country.GRC")}</option> */}
                                    <option value="299">{t("EDM.Country.GRL")}</option>
                                    <option value="1-473">{t("EDM.Country.GRD")}</option>
                                    {/* <option value="">{t("EDM.Country.GLP")}</option> */}
                                    <option value="1-671">{t("EDM.Country.GUM")}</option>
                                    <option value="502">{t("EDM.Country.GTM")}</option>
                                    <option value="44-1481">{t("EDM.Country.GGY")}</option>
                                    <option value="224">{t("EDM.Country.GIN")}</option>
                                    <option value="245">{t("EDM.Country.GNB")}</option>
                                    <option value="592">{t("EDM.Country.GUY")}</option>
                                    <option value="509">{t("EDM.Country.HTI")}</option>
                                    {/* <option value="">{t("EDM.Country.HMD")}</option> */}
                                    <option value="504">{t("EDM.Country.HND")}</option>
                                    {/* <option value="36">{t("EDM.Country.HUN")}</option> */}
                                    <option value="354">{t("EDM.Country.ISL")}</option>
                                    <option value="91">{t("EDM.Country.IND")}</option>
                                    <option value="98">{t("EDM.Country.IRN")}</option>
                                    <option value="964">{t("EDM.Country.IRQ")}</option>
                                    {/* <option value="353">{t("EDM.Country.IRL")}</option> */}
                                    <option value="44-1624">{t("EDM.Country.IMN")}</option>
                                    <option value="972">{t("EDM.Country.ISR")}</option>
                                    {/* <option value="39">{t("EDM.Country.ITA")}</option> */}
                                    <option value="225">{t("EDM.Country.CIV")}</option>
                                    <option value="1-876">{t("EDM.Country.JAM")}</option>
                                    <option value="44-1534">{t("EDM.Country.JEY")}</option>
                                    <option value="962">{t("EDM.Country.JOR")}</option>
                                    <option value="7">{t("EDM.Country.KAZ")}</option>
                                    <option value="254">{t("EDM.Country.KEN")}</option>
                                    <option value="686">{t("EDM.Country.KIR")}</option>
                                    <option value="82">{t("EDM.Country.KOR")}</option>
                                    <option value="383">{t("EDM.Country.XKX")}</option>
                                    <option value="965">{t("EDM.Country.KWT")}</option>
                                    <option value="996">{t("EDM.Country.KGZ")}</option>
                                    <option value="856">{t("EDM.Country.LAO")}</option>
                                    {/* <option value="371">{t("EDM.Country.LVA")}</option> */}
                                    <option value="961">{t("EDM.Country.LBN")}</option>
                                    <option value="266">{t("EDM.Country.LSO")}</option>
                                    <option value="231">{t("EDM.Country.LBR")}</option>
                                    <option value="218">{t("EDM.Country.LBY")}</option>
                                    <option value="423">{t("EDM.Country.LIE")}</option>
                                    {/* <option value="370">{t("EDM.Country.LTU")}</option> */}
                                    {/* <option value="352">{t("EDM.Country.LUX")}</option> */}
                                    <option value="389">{t("EDM.Country.MKD")}</option>
                                    <option value="261">{t("EDM.Country.MDG")}</option>
                                    <option value="265">{t("EDM.Country.MWI")}</option>
                                    <option value="60">{t("EDM.Country.MYS")}</option>
                                    <option value="960">{t("EDM.Country.MDV")}</option>
                                    <option value="223">{t("EDM.Country.MLI")}</option>
                                    {/* <option value="356">{t("EDM.Country.MLT")}</option> */}
                                    <option value="692">{t("EDM.Country.MHL")}</option>
                                    {/* <option value="">{t("EDM.Country.MTQ")}</option> */}
                                    <option value="222">{t("EDM.Country.MRT")}</option>
                                    <option value="230">{t("EDM.Country.MUS")}</option>
                                    <option value="262">{t("EDM.Country.MYT")}</option>
                                    <option value="52">{t("EDM.Country.MEX")}</option>
                                    <option value="691">{t("EDM.Country.FSM")}</option>
                                    <option value="373">{t("EDM.Country.MDA")}</option>
                                    <option value="377">{t("EDM.Country.MCO")}</option>
                                    <option value="976">{t("EDM.Country.MNG")}</option>
                                    <option value="382">{t("EDM.Country.MNE")}</option>
                                    <option value="1-664">{t("EDM.Country.MSR")}</option>
                                    <option value="212">{t("EDM.Country.MAR")}</option>
                                    <option value="258">{t("EDM.Country.MOZ")}</option>
                                    <option value="95">{t("EDM.Country.MMR")}</option>
                                    <option value="264">{t("EDM.Country.NAM")}</option>
                                    <option value="674">{t("EDM.Country.NRU")}</option>
                                    <option value="977">{t("EDM.Country.NPL")}</option>
                                    {/* <option value="31">{t("EDM.Country.NLD")}</option> */}
                                    <option value="599">{t("EDM.Country.ANT")}</option>
                                    <option value="687">{t("EDM.Country.NCL")}</option>
                                    <option value="64">{t("EDM.Country.NZL")}</option>
                                    <option value="505">{t("EDM.Country.NIC")}</option>
                                    <option value="227">{t("EDM.Country.NER")}</option>
                                    <option value="234">{t("EDM.Country.NGA")}</option>
                                    <option value="683">{t("EDM.Country.NIU")}</option>
                                    {/* <option value="">{t("EDM.Country.NFK")}</option> */}
                                    <option value="850">{t("EDM.Country.PRK")}</option>
                                    <option value="1-670">{t("EDM.Country.MNP")}</option>
                                    <option value="47">{t("EDM.Country.NOR")}</option>
                                    <option value="968">{t("EDM.Country.OMN")}</option>
                                    <option value="92">{t("EDM.Country.PAK")}</option>
                                    <option value="680">{t("EDM.Country.PLW")}</option>
                                    <option value="970">{t("EDM.Country.PSE")}</option>
                                    <option value="507">{t("EDM.Country.PAN")}</option>
                                    <option value="675">{t("EDM.Country.PNG")}</option>
                                    <option value="595">{t("EDM.Country.PRY")}</option>
                                    <option value="51">{t("EDM.Country.PER")}</option>
                                    <option value="63">{t("EDM.Country.PHL")}</option>
                                    <option value="64">{t("EDM.Country.PCN")}</option>
                                    {/* <option value="48">{t("EDM.Country.POL")}</option> */}
                                    {/* <option value="351">{t("EDM.Country.PRT")}</option> */}
                                    <option value="1-787, 1-939">{t("EDM.Country.PRI")}</option>
                                    <option value="974">{t("EDM.Country.QAT")}</option>
                                    <option value="381">{t("EDM.Country.SRB")}</option>
                                    <option value="242">{t("EDM.Country.COG")}</option>
                                    <option value="262">{t("EDM.Country.REU")}</option>
                                    {/* <option value="40">{t("EDM.Country.ROU")}</option> */}
                                    <option value="7">{t("EDM.Country.RUS")}</option>
                                    <option value="250">{t("EDM.Country.RWA")}</option>
                                    <option value="590">{t("EDM.Country.BLM")}</option>
                                    <option value="290">{t("EDM.Country.SHN")}</option>
                                    <option value="1-869">{t("EDM.Country.KNA")}</option>
                                    <option value="1-758">{t("EDM.Country.LCA")}</option>
                                    <option value="590">{t("EDM.Country.MAF")}</option>
                                    <option value="508">{t("EDM.Country.SPM")}</option>
                                    <option value="685">{t("EDM.Country.WSM")}</option>
                                    <option value="378">{t("EDM.Country.SMR")}</option>
                                    <option value="239">{t("EDM.Country.STP")}</option>
                                    <option value="966">{t("EDM.Country.SAU")}</option>
                                    <option value="221">{t("EDM.Country.SEN")}</option>
                                    <option value="248">{t("EDM.Country.SYC")}</option>
                                    <option value="232">{t("EDM.Country.SLE")}</option>
                                    <option value="1-721">{t("EDM.Country.SXM")}</option>
                                    {/* <option value="421">{t("EDM.Country.SVK")}</option> */}
                                    {/* <option value="386">{t("EDM.Country.SVN")}</option> */}
                                    <option value="677">{t("EDM.Country.SLB")}</option>
                                    <option value="252">{t("EDM.Country.SOM")}</option>
                                    <option value="27">{t("EDM.Country.ZAF")}</option>
                                    <option value="211">{t("EDM.Country.SSD")}</option>
                                    {/* <option value="34">{t("EDM.Country.ESP")}</option> */}
                                    <option value="94">{t("EDM.Country.LKA")}</option>
                                    <option value="1-784">{t("EDM.Country.VCT")}</option>
                                    <option value="249">{t("EDM.Country.SDN")}</option>
                                    <option value="597">{t("EDM.Country.SUR")}</option>
                                    <option value="47">{t("EDM.Country.SJM")}</option>
                                    <option value="268">{t("EDM.Country.SWZ")}</option>
                                    {/* <option value="46">{t("EDM.Country.SWE")}</option> */}
                                    <option value="41">{t("EDM.Country.CHE")}</option>
                                    <option value="963">{t("EDM.Country.SYR")}</option>
                                    <option value="992">{t("EDM.Country.TJK")}</option>
                                    <option value="255">{t("EDM.Country.TZA")}</option>
                                    <option value="1-284">{t("EDM.Country.VGB")}</option>
                                    <option value="228">{t("EDM.Country.TGO")}</option>
                                    <option value="690">{t("EDM.Country.TKL")}</option>
                                    <option value="676">{t("EDM.Country.TON")}</option>
                                    <option value="1-868">{t("EDM.Country.TTO")}</option>
                                    <option value="216">{t("EDM.Country.TUN")}</option>
                                    <option value="90">{t("EDM.Country.TUR")}</option>
                                    <option value="993">{t("EDM.Country.TKM")}</option>
                                    <option value="1-649">{t("EDM.Country.TCA")}</option>
                                    <option value="688">{t("EDM.Country.TUV")}</option>
                                    <option value="256">{t("EDM.Country.UGA")}</option>
                                    <option value="380">{t("EDM.Country.UKR")}</option>
                                    <option value="971">{t("EDM.Country.ARE")}</option>
                                    {/* <option value="44">{t("EDM.Country.GBR")}</option> */}
                                    {/* <option value="1">{t("EDM.Country.USA")}</option> */}
                                    {/* <option value="">{t("EDM.Country.UMI")}</option> */}
                                    <option value="598">{t("EDM.Country.URY")}</option>
                                    <option value="998">{t("EDM.Country.UZB")}</option>
                                    <option value="678">{t("EDM.Country.VUT")}</option>
                                    <option value="379">{t("EDM.Country.VAT")}</option>
                                    <option value="58">{t("EDM.Country.VEN")}</option>
                                    <option value="84">{t("EDM.Country.VNM")}</option>
                                    <option value="1-340">{t("EDM.Country.VIR")}</option>
                                    <option value="681">{t("EDM.Country.WLF")}</option>
                                    <option value="212">{t("EDM.Country.ESH")}</option>
                                    <option value="967">{t("EDM.Country.YEM")}</option>
                                    <option value="260">{t("EDM.Country.ZMB")}</option>
                                    <option value="263">{t("EDM.Country.ZWE")}</option>
                                </Form.Select>
                                <span className={classes.errorMsg}>{formik.errors.mobileCountryCode && formik.touched.mobileCountryCode && t(formik.errors.mobileCountryCode)}</span>
                            </Col>
                            <Col xs={6}>
                                <Form.Control type="text" name="mobileNumber" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.mobileNumber} onKeyPress={(event) => {if (!/[0-9]/.test(event.key)) {event.preventDefault();}}} />
                                <span className={classes.errorMsg}>{formik.errors.mobileNumber && formik.touched.mobileNumber && getMobileNoErrorMsg(formik.errors.mobileNumber)}</span>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Form.Label>{t("EDM.Email")}*</Form.Label>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Form.Control type="text" name="email" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} />
                                <span className={classes.errorMsg}>{formik.errors.email && formik.touched.email && t(formik.errors.email)}</span>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Form.Label className={classes.mandatoryLabel}>*{t("EDM.MandatoryFieldsAreRequired")}</Form.Label>
                        </Row>
                        
                        <Row className="mt-3">
                            <Form.Label>{t("EDM.PleaseInputVerificationCode")}*</Form.Label>
                            <Col xs={6}>
                                <Form.Control type="text" name="captchaCode" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.captchaCode} />
                                <span className={classes.errorMsg}>{formik.errors.captchaCode && formik.touched.captchaCode && t(formik.errors.captchaCode)}</span>
                            </Col>
                            <Col xs={3}>
                                <img className={classes.captchaStyle} src={"data:image/png;base64," + captchaB64Str} alt="captcha" />
                            </Col>
                            <Col xs={2} style={{margin: "auto"}}>
                                <Button style={{backgroundColor: "transparent", border: "none"}} onClick={refreshCaptcha}><FontAwesomeIcon icon={faSyncAlt} style={{color: "black"}}/></Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Control type="hidden" name="referenceNo" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.referenceNo} />
                            </Col>
                        </Row>
                    </div>
                    
                    <div style={{padding: "10px 30px", maxWidth: "800px", margin: "auto"}} className="mt-3">
                        <div style={{color: "#818181"}}>
                            <p>{t("EDM.AgreementDesc1")}<a href="#/" onClick={showDataPrivacy}>{t("PersonalInformationCollectionStatement")}</a>{t("EDM.AgreementDesc2")}</p>
                            <p>{t("EDM.AgreementDesc3")}</p>
                            <p>{t("EDM.AgreementDesc4")}</p>
                        </div>
                    </div>

                    <div className={classes.form}>
                        <Row className="mb-3">
                            <Button as="input" type="submit" value={t("EDM.AgreeAndSubmit")} className={classes.submitButton} />
                        </Row>
                    </div>

                    <div style={{padding: "10px 30px", maxWidth: "800px", margin: "auto"}} className="mt-3">
                        <div style={{color: "#818181"}}>
                            <p>{t("EDM.KGIHKWillNotSoUseYourPeronalData")}</p>
                        </div>
                    </div>
                </Form>
            </div>

            <div className={classes.footer}>
                <EDMFooter/>
            </div>
    
            <Modal
                size="lg"
                show={showModal}
                onHide={() => handleCloseModal()}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalHeader}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalContent}
                </Modal.Body>
            </Modal>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
                onClick={() => {setLoading(false)}}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default EDMTWSubmit;